module.exports = __webpack_public_path__ + "img/info_20_black.f2a45f1b.svg";